"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSCredentialError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const InternalServerError_1 = require("./InternalServerError");
class AWSCredentialError extends InternalServerError_1.InternalServerError {
    constructor() {
        super('aws_credentials_missing', 'AWS instance credentials could not be found!');
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 'aws_credentials_missing', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], AWSCredentialError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        defaultValue: 'AWS instance credentials could not be found!',
        description: 'Describing what went wrong',
    }),
    tslib_1.__metadata("design:type", String)
], AWSCredentialError.prototype, "message", void 0);
exports.AWSCredentialError = AWSCredentialError;
